// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__38kJ6","errorLogs":"EditorFooter_errorLogs__18tAC"};